import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactGA from 'react-ga';

import { Box, Flex, Image, Text } from 'Components/Base';
import { FONT_SIZE } from 'Components/Theme';

const CustomImage = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 100%;
`;

const onHandleClick = subjectCode => {
  try {
    ReactGA.event({
      category: 'CAMPAIGN_MF_2562-01',
      action: 'Recommened Course Banner Click',
      label: `SubjectCode:${subjectCode}`,
    });
  } catch (err) {
    console.log('ga error:', err);
  }
};

const getWidthByColumn = columnCount => {
  const spacing = '16px';
  return `calc((100% - (${spacing} * ${columnCount - 1})) / ${columnCount})`;
};

const RecommendedCard = ({ img, href, subjectCode }) => (
  <Box
    as={'a'}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => onHandleClick(subjectCode)}
    my={2}
    width={['100%', getWidthByColumn(2), getWidthByColumn(4)]}
    style={{ display: 'flex', justifyContent: 'center', height: 'fit-content' }}
  >
    <CustomImage src={img} />
  </Box>
);

const RecommendedCoursesView = ({ courses }) => (
  <Box mb={48}>
    <Text fontSize={FONT_SIZE.large} style={{ marginBottom: '24px' }}>
      คอร์สแนะนำ
    </Text>
    <Flex
      flexDirection={'row'}
      flexWrap={'wrap'}
      alignItems={'center'}
      justifyContent={'space-between'}
      px={[4, null, 0]}
    >
      {courses.map((course, index) => (
        <RecommendedCard
          key={`${index}_${course.subjectCode}`}
          img={course.img}
          subjectCode={course.subjectCode}
          href={course.href}
        />
      ))}
    </Flex>
  </Box>
);

RecommendedCoursesView.defaultProps = {
  courses: [],
};

export default RecommendedCoursesView;
